import React from 'react';

/**
 * Standard header for a Settings sub-page: large title, optional subtitle, and
 * an optional right-aligned actions slot.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.title - Page title (H1).
 * @param {React.ReactNode} [props.subtitle] - Short description of the page.
 * @param {React.ReactNode} [props.actions] - Right-aligned action buttons.
 * @returns {JSX.Element}
 */
export default function SettingsHeader({ title, subtitle, actions }) {
  return (
    <header className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="font-heading text-[28px] leading-none text-ink dark:text-gray-100">{title}</h1>
        {subtitle && (
          <p className="text-gray-500 dark:text-gray-400 text-[14.5px] mt-2 max-w-[640px]">{subtitle}</p>
        )}
      </div>
      {actions && <div className="shrink-0">{actions}</div>}
    </header>
  );
}
